<div class="container" #content>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-12">
          <div class="breadcrumb-title border-0 mb-3">
            <div
              class="d-flex justify-content-start align-items-center gap-2 flex-wrap"
            >
              <mat-icon color="primary">assessment</mat-icon>
              <p class="text-break text-wrap mb-0">
                {{ "Remains.Report_View" | translate }}
              </p>
              <mat-icon
                class="cursor-pointer ms-1"
                color="primary"
                [matTooltip]="'customReport.buttons.downloadPDF' | translate"
                matTooltipPosition="right"
                (click)="exportPDFData()"
              >
                picture_as_pdf
              </mat-icon>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="card">
            <div class="card-header border-bottom-0">
              <button
                mat-stroked-button
                color="primary"
                (click)="toggleSearchInputs()"
                [title]="'customReport.filter.tooltips.filter' | translate"
              >
                <mat-icon>tune</mat-icon>
                <span>{{ "customReport.filter.title" | translate }}</span>
              </button>
            </div>
            <div class="card-body">
              <div
                *ngIf="showSearchInputs"
                class="pb-0 compact-inputs dropdown-pd-none"
              >
                <div class="container-fluid p-0 mb-3">
                  <!-- Filter inputs row -->
                  <div class="row g-2">
                    <!-- Field Selection -->
                    <div class="col-lg-auto col-md-6 col-12">
                      <div class="d-flex align-items-center">
                        <mat-form-field
                          appearance="outline"
                          class="w-100"
                          subscriptSizing="dynamic"
                        >
                          <mat-select
                            [(ngModel)]="searchData['field']"
                            name="field"
                            [placeholder]="
                              'customReport.filter.placeholders.selectField'
                                | translate
                            "
                          >
                            <mat-select-trigger>
                              {{
                                searchData["field"]?.replace("D ", "") ||
                                  ("customReport.filter.placeholders.selectField"
                                    | translate)
                              }}
                            </mat-select-trigger>
                            <mat-option
                              *ngFor="let e of filterAttributes"
                              [value]="e['code']"
                              (click)="selectSearch(e, 'field')"
                            >
                              <div class="d-flex align-items-center gap-2 py-1">
                                <span
                                  class="badge"
                                  [ngClass]="getButtonClass(e['type'])"
                                >
                                  {{ getButtonLabels(e["type"]) }}
                                </span>
                                <span
                                  [matTooltip]="e['label']"
                                  class="text-truncate"
                                >
                                  {{ e["label"] }}
                                </span>
                              </div>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-icon
                          class="icon-compact text-secondary"
                          [matTooltip]="
                            'customReport.filter.tooltips.field' | translate
                          "
                          matTooltipPosition="above"
                          >info</mat-icon
                        >
                      </div>
                    </div>

                    <!-- Condition Selection -->
                    <div class="col-lg-auto col-md-6 col-12">
                      <div class="d-flex align-items-center">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select
                            [(ngModel)]="searchData['condition']"
                            name="condition"
                            [placeholder]="
                              'customReport.filter.placeholders.selectCondition'
                                | translate
                            "
                          >
                            <mat-option
                              *ngFor="let e of operators"
                              [value]="e.value"
                            >
                              {{ e.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-icon
                          class="text-secondary icon-compact"
                          [matTooltip]="
                            'customReport.filter.tooltips.condition' | translate
                          "
                          matTooltipPosition="above"
                          >info</mat-icon
                        >
                      </div>
                    </div>

                    <!-- Value Input Section -->
                    <div class="col-lg-auto col-md-12">
                      <div
                        class="d-flex align-items-center flex-wrap flex-sm-nowrap gap-1"
                      >
                        <div class="d-flex flex-sm-nowrap align-items-center">
                          <ng-container
                            *ngIf="
                              !['NULL', 'NOT NULL', 'EMPTY'].includes(
                                searchData['condition']
                              )
                            "
                          >
                            <!-- Custom Day Dropdown -->
                            <div
                              class="custom-dropdown-wrapper flex-shrink-0"
                              *ngIf="
                                searchData['condition'] === 'DAY' &&
                                selectedSearchAtt === 'date'
                              "
                              style="min-width: 90px"
                            >
                              <div
                                class="custom-dropdown"
                                (click)="
                                  toggleDayDropdown(); $event.stopPropagation()
                                "
                              >
                                <span>{{ selectedDay || "Select Day" }}</span>
                                <i class="fa fa-chevron-down"></i>
                              </div>
                              <ul *ngIf="dayDropdownOpen" class="dropdown-list">
                                <li
                                  *ngFor="let day of days; let i = index"
                                  [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectDay(day); $event.stopPropagation()
                                  "
                                >
                                  {{ day }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                                </li>
                              </ul>
                            </div>

                            <!-- Custom Month Dropdown -->
                            <div
                              class="custom-dropdown-wrapper flex-shrink-0"
                              *ngIf="
                                searchData['condition'] === 'MONTH' &&
                                selectedSearchAtt === 'date'
                              "
                              style="min-width: 90px"
                            >
                              <div
                                class="custom-dropdown"
                                (click)="
                                  toggleMonthDropdown();
                                  $event.stopPropagation()
                                "
                              >
                                <span>{{
                                  getMonthName(selectedMonth) || "Select Month"
                                }}</span>
                                <i class="fa fa-chevron-down"></i>
                              </div>
                              <ul
                                *ngIf="monthDropdownOpen"
                                class="dropdown-list"
                              >
                                <li
                                  *ngFor="let month of months; let i = index"
                                  [class.sticky-first-item]="i === 0"
                                  (click)="
                                    selectMonth(month); $event.stopPropagation()
                                  "
                                >
                                  {{ month.name }}
                                  <div
                                    *ngIf="i === 0"
                                    class="dropdown-separator"
                                  ></div>
                                </li>
                              </ul>
                            </div>

                            <!-- Day + Month Combined -->
                            <div
                              *ngIf="
                                searchData['condition'] === 'DAY_AND_MONTH' &&
                                selectedSearchAtt === 'date'
                              "
                              class="d-flex gap-1 flex-shrink-0"
                            >
                              <div
                                class="custom-dropdown-wrapper"
                                style="min-width: 70px"
                              >
                                <div
                                  class="custom-dropdown custom-dropdown_dm"
                                  (click)="
                                    toggleDayDropdown();
                                    $event.stopPropagation()
                                  "
                                >
                                  <span>{{ selectedDay || "D" }}</span>
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul
                                  *ngIf="dayDropdownOpen"
                                  class="dropdown-list"
                                >
                                  <li
                                    *ngFor="let day of days; let i = index"
                                    [class.sticky-first-item]="i === 0"
                                    (click)="
                                      selectDayForDayMonth(day);
                                      $event.stopPropagation()
                                    "
                                  >
                                    {{ day }}
                                    <div
                                      *ngIf="i === 0"
                                      class="dropdown-separator"
                                    ></div>
                                  </li>
                                </ul>
                              </div>
                              <div
                                class="custom-dropdown-wrapper"
                                style="min-width: 70px"
                              >
                                <div
                                  class="custom-dropdown custom-dropdown_dm"
                                  (click)="
                                    toggleMonthDropdown();
                                    $event.stopPropagation()
                                  "
                                >
                                  <span>{{
                                    getMonthName(selectedMonth) || "M"
                                  }}</span>
                                  <i class="fa fa-chevron-down"></i>
                                </div>
                                <ul
                                  *ngIf="monthDropdownOpen"
                                  class="dropdown-list"
                                >
                                  <li
                                    *ngFor="let month of months; let i = index"
                                    [class.sticky-first-item]="i === 0"
                                    (click)="
                                      selectMonthForDayMonth(month);
                                      $event.stopPropagation()
                                    "
                                  >
                                    {{ month.name }}
                                    <div
                                      *ngIf="i === 0"
                                      class="dropdown-separator"
                                    ></div>
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <!-- BETWEEN Range -->
                            <ng-container
                              *ngIf="searchData['condition'] === 'BETWEEN'"
                            >
                              <div
                                class="d-flex flex-nowrap align-items-center"
                                style="flex: 1"
                              >
                                <!-- Text Range -->
                                <ng-container
                                  *ngIf="selectedSearchAtt === 'text'"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="Enter From value"
                                      type="text"
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="Enter To value"
                                      type="text"
                                    />
                                  </mat-form-field>
                                </ng-container>

                                <!-- Number Range -->
                                <ng-container
                                  *ngIf="
                                    selectedSearchAtt === 'number' ||
                                    selectedSearchAtt === 'expression' ||
                                    selectedSearchAtt === 'long'
                                  "
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="Enter From value"
                                      type="number"
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="Enter To value"
                                      type="number"
                                    />
                                  </mat-form-field>
                                </ng-container>

                                <!-- Date Range -->
                                <input
                                  *ngIf="selectedSearchAtt === 'date'"
                                  type="text"
                                  class="form-control form-control-sm"
                                  ngxDaterangepickerMd
                                  [(ngModel)]="searchData['rangeDate']"
                                  [showCustomRangeLabel]="true"
                                  [alwaysShowCalendars]="true"
                                  [ranges]="ranges"
                                  [showDropdowns]="true"
                                  [linkedCalendars]="true"
                                  placeholder="Select please..."
                                  style="width: 180px"
                                />
                              </div>
                            </ng-container>

                            <!-- Regular Inputs (non-BETWEEN) -->
                            <ng-container
                              *ngIf="
                                searchData['condition'] !== 'BETWEEN' &&
                                searchData['condition'] !== 'DAY' &&
                                searchData['condition'] !== 'MONTH' &&
                                searchData['condition'] !== 'DAY_AND_MONTH'
                              "
                            >
                              <!-- Text Input -->
                              <mat-form-field
                                *ngIf="
                                  selectedSearchAtt !== 'number' &&
                                  selectedSearchAtt !== 'expression' &&
                                  selectedSearchAtt !== 'long' &&
                                  selectedSearchAtt !== 'date'
                                "
                                appearance="outline"
                                class="flex-grow-1"
                                subscriptSizing="dynamic"
                                style="min-width: 120px"
                              >
                                <input
                                  matInput
                                  [(ngModel)]="searchData['value']"
                                  placeholder="{{
                                    'Remains.Enter_New' | translate
                                  }}"
                                  type="text"
                                />
                              </mat-form-field>

                              <!-- Number Input -->
                              <mat-form-field
                                *ngIf="
                                  selectedSearchAtt === 'number' ||
                                  selectedSearchAtt === 'expression' ||
                                  selectedSearchAtt === 'long'
                                "
                                appearance="outline"
                                class="flex-grow-1"
                                subscriptSizing="dynamic"
                                style="min-width: 120px"
                              >
                                <input
                                  matInput
                                  [(ngModel)]="searchData['value']"
                                  placeholder="Enter search value"
                                  type="number"
                                />
                              </mat-form-field>

                              <!-- Date Input -->
                              <mat-form-field
                                appearance="outline"
                                class="w-100"
                                *ngIf="selectedSearchAtt === 'date'"
                              >
                                <input
                                  matInput
                                  type="date"
                                  #dateInput
                                  [(ngModel)]="searchData['value']"
                                />
                                <button
                                  mat-icon-button
                                  matSuffix
                                  type="button"
                                  class="icon-pd-none"
                                  (click)="dateInput.showPicker()"
                                  aria-label="Open date picker"
                                >
                                  <mat-icon class="icon-compact text-secondary"
                                    >event</mat-icon
                                  >
                                </button>
                              </mat-form-field>
                            </ng-container>

                            <!-- BETWEEN Range -->
                            <ng-container
                              *ngIf="searchData['condition'] === 'BETWEEN'"
                            >
                              <div
                                class="d-flex flex-nowrap align-items-center"
                                style="flex: 1"
                              >
                                <!-- Text Range -->
                                <ng-container
                                  *ngIf="selectedSearchAtt === 'text'"
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="Enter From value"
                                      type="text"
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="Enter To value"
                                      type="text"
                                    />
                                  </mat-form-field>
                                </ng-container>

                                <!-- Number Range -->
                                <ng-container
                                  *ngIf="
                                    selectedSearchAtt === 'number' ||
                                    selectedSearchAtt === 'expression' ||
                                    selectedSearchAtt === 'long'
                                  "
                                >
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeFrom']"
                                      placeholder="{{
                                        'customReport.filter.placeholders.fromValue'
                                          | translate
                                      }}"
                                      type="number"
                                    />
                                  </mat-form-field>
                                  <mat-form-field
                                    appearance="outline"
                                    subscriptSizing="dynamic"
                                    style="width: 180px"
                                  >
                                    <input
                                      matInput
                                      [(ngModel)]="searchData['rangeTo']"
                                      placeholder="{{
                                        'customReport.filter.placeholders.toValue'
                                          | translate
                                      }}"
                                      type="number"
                                    />
                                  </mat-form-field>
                                </ng-container>

                                <!-- Date Range - Simplified without ranges object -->
                                <input
                                  *ngIf="selectedSearchAtt === 'date'"
                                  type="text"
                                  class="form-control form-control-sm"
                                  placeholder="Select date range"
                                  style="width: 220px"
                                />
                              </div>
                            </ng-container>

                            <!-- Tooltip Icon -->
                            <mat-icon
                              *ngIf="selectedSearchAtt"
                              class="icon-compact text-secondary"
                              [matTooltip]="'TOOLTIPS.FILTER_VALUE' | translate"
                              matTooltipPosition="above"
                              >info</mat-icon
                            >
                          </ng-container>
                        </div>

                        <!-- Add Button -->
                        <button
                          mat-stroked-button
                          color="primary"
                          class="flex-shrink-0"
                          [disabled]="
                            !searchData['value'] &&
                            !searchData['condition'] &&
                            !searchData['field']
                          "
                          (click)="addSearchData()"
                        >
                          <mat-icon>add</mat-icon>
                          {{ "COMMON.ADD" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Applied Filters -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="d-flex flex-wrap align-items-center gap-1">
                        <button
                          *ngFor="let e of searchList; let i = index"
                          (click)="removeSearchData(i)"
                          type="button"
                          class="btn btn-outline-secondary btn-sm m-1 p-1 d-inline-flex align-items-center"
                        >
                          <ng-container [ngSwitch]="e.condition">
                            <span *ngSwitchCase="'Day'">
                              {{ e.field }} {{ e.condition }} :
                              {{ e.value?.split("-")[2] }}
                            </span>
                            <span *ngSwitchCase="'Month'">
                              {{ e.field }} {{ e.condition }} :
                              {{ e.value?.split("-")[1] }}
                            </span>
                            <span *ngSwitchCase="'Day & Month'">
                              {{ e.field }} Day:
                              {{ e.value?.split("-")[2] }} Month:
                              {{ e.value?.split("-")[1] }}
                            </span>
                            <span *ngSwitchDefault>
                              {{ e.field }} {{ e.condition }} {{ e.value }}
                              <ng-container *ngIf="e.rangeFrom">
                                {{ e.rangeFrom }}
                              </ng-container>
                              <ng-container *ngIf="e.rangeTo">
                                - {{ e.rangeTo }}
                              </ng-container>
                            </span>
                          </ng-container>
                          <i class="fa fa-times ms-1 fs-6"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Action Buttons -->
                  <div class="row mt-2">
                    <div class="col-12">
                      <div class="d-flex align-items-center gap-2">
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="searchAndDrawnew(true)"
                        >
                          <mat-icon class="me-1">search</mat-icon>
                          {{ "customReport.buttons.search" | translate }}
                        </button>
                        <button
                          mat-stroked-button
                          color="primary"
                          (click)="resetSearchCriteria()"
                        >
                          <i class="fa fa-eraser"></i>
                          <span class="ms-2">{{
                            "customReport.buttons.reset" | translate
                          }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Report Display Area -->
              <div>
                <div
                  class="d-flex align-items-center justify-content-between border-bottom pb-2"
                >
                  <div class="d-flex align-items-center gap-2">
                    <mat-icon color="primary" class="fs-4">table_view</mat-icon>
                    <h6 class="mb-0 fw-semibold">
                      {{ reportTitle }}
                    </h6>
                  </div>
                </div>

                <!-- Report Content -->
                <div class="mt-3">
                  <p *ngIf="form['error'] == false && form['message']">
                    <app-ncs-alert
                      [message]="form['message']"
                      type="success"
                      showAlert="true"
                    />
                  </p>
                  <p *ngIf="form['error'] == true && form['message']">
                    <app-ncs-alert
                      [message]="form['message']"
                      type="danger"
                      showAlert="true"
                    />
                  </p>
                <div *ngIf="loading" class="text-center py-5">loading ...</div>
            <!-- <div *ngIf="!loading">
                  <div [innerHTML]="pivottable" class="table-responsive"></div>
                    <img [src]="pivotUrl" width="100%" class="mt-3" />
                </div> -->
              <!-- TABLE -->

              <div *ngIf="pivottable && !chartUrl" [innerHTML]="pivottable" class="table-responsive sticky-bordered-table">
                  </div>

              <!-- CHART -->

              <iframe #chartIframe *ngIf="isChartMode && pivotUrl" [src]="pivotUrl" width="100%" height="700" style="border:none">
              </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
